<template>
  <div class="footer">
    <div class="footer-links">
      <a href="https://wyc-fe-static.yun-sk.com/static/b2b/dianxin.png" target="_blank">增值电信业务经营许可证 ：川B2-20231817</a>
      <a href="https://beian.miit.gov.cn" target="_blank">蜀ICP备2024010001号-1</a>
    </div>
    <div class="copyright">
      Copyright <a-icon type="copyright" />
      <span style="white-space: pre-line">{{copyright}}</span>
    </div>
  </div>
</template>

<script>
export default {
    name: "GlobalFooter",
    props: ["copyright"]
};
</script>

<style lang="less" scoped>
.footer {
    padding: 0 16px;
    margin: 24px 0 24px;
    text-align: center;
    .copyright {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
        line-height: 22px;
    }
    .footer-links {
        margin-bottom: 8px;
        a {
            color: rgba(0, 0, 0, 0.45);
            -webkit-transition: all 0.3s;
            transition: all 0.3s;
            &:not(:last-child) {
                margin-right: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/layouts/GlobalFooter.vue